@if (showAsOverlay) {
<div class="megasearch-results-host">
  <ng-template #overlayContent>
    <div class="work-office-global-megasearch-results">
      <ng-template [ngTemplateOutlet]="resultList"></ng-template>
    </div>
  </ng-template>
</div>
} @else {
<ng-template [ngTemplateOutlet]="resultList"></ng-template>
}

<ng-template #resultList>
  @if (WorkMegasearchResultDto) {
  <div [@overlayAnimation]>
    @if (hasNoResults()) {
    <p class="padding-24 work-text-color-light">{{ 'KEINE_SUCHTREFFER' | translate }}</p>
    } @if (rawContactAndProjects().length) {
    <div class="work-office-global-megasearch-results-group">
      <h4>{{ 'KONTAKTE' | translate }} & {{ 'PROJEKTE' | translate }}</h4>
      @if (enableContactAndProjectsFilter() && (contactCategories().length || projectStatuses().length)) {
      <div class="work-office-global-megasearch-results-filter padding-horizontal-16">
        <work-ui-accordion-item [isOpen]="false" [withBorder]="false" [noPadding]="true" [headerNoHoverEffect]="true">
          <span accordion-header class="flex flex-row vertical-center gap-8 work-text-color-light">
            <work-ui-icon name="tune" [fontSize]="20" />
            <small
              ><b>{{ 'FILTER' | translate }}</b></small
            >
          </span>
          <div accordion-content class="flex flex-column gap-12 padding-top-12 padding-bottom-12">
            @if (contactCategories().length) {
            <div class="flex flex-column gap-8">
              <small class="work-text-color-light">{{ 'KATEGORIE' | translate }}</small>
              <div class="flex flex-row vertical-center gap-16 wrap">
                @for (contactCategory of contactCategories(); track contactCategory.id) {
                <work-ui-checkbox
                  [checked]="contactCategoryIdFilters().includes(contactCategory.id)"
                  [label]="contactCategory.name ? contactCategory.name : ''"
                  [noMargin]="true"
                  (checkedChange)="updateContactCategoryIdFilter(contactCategory.id, $event)"
                />
                }
              </div>
            </div>
            } @if (projectStatuses().length) {
            <div class="flex flex-column gap-8">
              <small class="work-text-color-light">{{ 'STATUS' | translate }}</small>
              <div class="flex flex-row vertical-center gap-24 wrap">
                @for (projectStatus of projectStatuses(); track projectStatus.id) {
                <work-ui-checkbox
                  [checked]="projectStatusIdFilters().includes(projectStatus.id)"
                  [label]="projectStatus.name ? projectStatus.name : ''"
                  [noMargin]="true"
                  (checkedChange)="updateProjectStatusIdFilter(projectStatus.id, $event)"
                />
                }
              </div>
            </div>
            }
          </div>
        </work-ui-accordion-item>
      </div>
      } @for (contactAndProjects of displayedContactAndProjects(); track $index) { @if (!disableResultContactLinks() ||
      disableResultContactLinks() && contactAndProjects.projects.length > 0) {
      <work-office-global-megasearch-result-contact-and-projects
        (contactClicked)="contactClicked.emit($event); WorkMegasearchResultDto = undefined; toggleResults(false)"
        (projectClicked)="projectClicked.emit($event); WorkMegasearchResultDto = undefined; toggleResults(false)"
        [contactAndProjects]="contactAndProjects"
        [renderContactAsLink]="renderContactAsLink"
        [renderProjectAsLink]="renderProjectAsLink"
        [searchterm]="searchterm"
        [disableResultContactLinks]="disableResultContactLinks()"
        [disableResultProjectLinks]="disableResultProjectLinks()"
      />
      } } @if (!displayedContactAndProjects().length) {
      <p class="inline-padding padding-bottom-12 work-text-color-light">
        <small>{{ 'KEINE_SUCHTREFFER' | translate }}</small>
      </p>
      }
    </div>
    } @if (WorkMegasearchResultDto && WorkMegasearchResultDto.items && WorkMegasearchResultDto.items.length) {
    <div class="work-office-global-megasearch-results-group">
      <h4>{{ 'ARTIKEL' | translate }}</h4>
      @for (item of WorkMegasearchResultDto.items; track item.entity.id) {
      <work-ui-infoblock
        (click)="itemClicked.emit(item.entity); WorkMegasearchResultDto = undefined; toggleResults(false)"
        [avatarImgSrc]="item.entity.documents | getItemProductimagePathFromDocuments"
        [avatarSquare]="true"
        [clickable]="true"
        [textCenteredVertically]="true"
        [label]="(item.entity.productgroup ? item.entity.productgroup.name : null) | highlight : searchterm"
        [listElement]="true"
        [subtitle]="(item.entity.producer ? item.entity.producer.company : null) | highlight : searchterm"
        [title]="item.entity.name || '' | highlight : searchterm"
        [route]="renderItemAsLink ? '/' + AppRoutePaths.ARTIKEL + '/' + AppRouteViewTypes.DETAILS + '/' + item.entity.id : undefined"
        avatarStatus="none"
      />
      }
    </div>
    } @if (WorkMegasearchResultDto && WorkMegasearchResultDto.equipments && WorkMegasearchResultDto.equipments.length) {
    <div class="work-office-global-megasearch-results-group">
      <h4>{{ 'BETRIEBSMITTEL' | translate }}</h4>
      @for (equipment of WorkMegasearchResultDto.equipments; track equipment.entity.id) {
      <work-ui-infoblock
        (click)="equipmentClicked.emit(equipment.entity); WorkMegasearchResultDto = undefined; toggleResults(false)"
        [clickable]="true"
        [iconName]="equipment.entity.equipmenttype?.id | getEquipmenttypeIconName"
        [label]="equipment.entity.equipmenttype?.name | highlight : searchterm"
        [listElement]="true"
        [textCenteredVertically]="true"
        [route]="
          renderEquipmentAsLink
            ? '/' + AppRoutePaths.BETRIEBSMITTEL + '/' + AppRouteViewTypes.DETAILS + '/' + equipment.entity.id
            : undefined
        "
        [subtitle]="equipment.entity.identifier | highlight : searchterm"
        [title]="equipment.entity.brand + ' ' + equipment.entity.model | highlight : searchterm"
      />
      }
    </div>
    } @if (WorkMegasearchResultDto && WorkMegasearchResultDto.stocklocations && WorkMegasearchResultDto.stocklocations.length) {
    <div class="work-office-global-megasearch-results-group">
      <h4>{{ 'LAGERORTE' | translate }}</h4>
      @for (stocklocation of WorkMegasearchResultDto.stocklocations; track stocklocation.entity.id) {
      <work-ui-infoblock
        (click)="stocklocationClicked.emit(stocklocation.entity); WorkMegasearchResultDto = undefined; toggleResults(false)"
        [clickable]="true"
        [iconName]="'home'"
        [listElement]="true"
        [textCenteredVertically]="true"
        [title]="stocklocation.entity.name | highlight : searchterm"
        [route]="
          renderStocklocationAsLink
            ? '/' + AppRoutePaths.ADMIN + '/lagerorte/' + AppRouteViewTypes.DETAILS + '/' + stocklocation.entity.id
            : undefined
        "
      />
      }
    </div>
    } @if (WorkMegasearchResultDto && WorkMegasearchResultDto.users && WorkMegasearchResultDto.users.length) {
    <div class="work-office-global-megasearch-results-group">
      <h4>{{ 'TEAM' | translate }}</h4>
      @for (user of WorkMegasearchResultDto.users; track user.entity.id) { @let employmentHint = user.entity | userEmploymentHintPipe;
      <div (click)="userClicked.emit(user.entity); toggleResults(false)">
        <work-ui-infoblock
          [avatarImgSrc]="user.entity.userImage ? (user.entity.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
          [clickable]="true"
          [label]="
            employmentHint ? (user.entity.jobtitle ? user.entity.jobtitle + ' · ' : '') + employmentHint : user.entity.jobtitle || ''
          "
          [listElement]="true"
          [route]="renderUserAsLink ? '/' + AppRoutePaths.MITARBEITER + '/' + AppRouteViewTypes.DETAILS + '/' + user.entity.id : undefined"
          [subtitle]="('GEFUNDEN_IN' | translate) + ': ' + (user.foundInProperty | joinBy : ', ')"
          [title]="user.entity.firstName! + ' ' + user.entity.lastName! || ''"
          [withAvatar]="true"
          [textCenteredVertically]="true"
          avatarSize="small"
          avatarStatus="none"
        />
      </div>
      }
    </div>
    }
  </div>
  }
</ng-template>
